import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLayout from "./layouts/AdminLayout";
import AreaPage from "./pages/AreaPage";
import ProtectedRoute from "./utils/ProtectedRoute";
import AdminDashboard from "./pages/Admin/AdminDashboard";

/* WEBSITE */
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Service from "./pages/Service";
import About from "./pages/About";
import BrandsPage from "./pages/Brand";
import TrackRepair from "./pages/TrackRepair";
import ThankYou from "./pages/Thank-you";
import PrivacyPolicy from "./pages/privacy-policy";
import Terms from "./pages/Trems";
import LGMain from "./pages/LGService";
import WashingMachineService from "./pages/WashingMachineService";
import FridgeService from "./pages/FridgeService";
import ACService from "./pages/ACService";
import BrandServicePage from "./pages/BrandServicePage";
import LGWashingMachineService from "./pages/LGWashingMachineService";
import LGWashingMachineRepair from "./pages/LGWashingMachineRepair";
import LGWashingMachineNotSpinning from "./pages/LGWashingMachineNotSpinning";
import LGFrontLoadService from "./pages/LGFrontLoadService";
import LGTopLoadService from "./pages/LGTopLoadService";
import LGWashingMachineNotWorking from "./pages/LGWashingMachineNotWorking";
import LGWashingMachineWaterLeakRepair from "./pages/LGWashingMachineWaterLeakRepair";
import LGWashingMachineNoPowerIssue from "./pages/LGWashingMachineNoPowerIssue";
import LGWashingMachineNoiseProblem from "./pages/LGWashingMachineNoiseProblem";
import LGWashingMachineDrumRepair from "./pages/LGWashingMachineDrumRepair";

/* ADMIN */
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminRegister from "./pages/Admin/AdminRegister";
import AdminServices from "./pages/Admin/AdminServices";
import Brands from "./pages/Admin/Brands";
import Orders from "./pages/Admin/Orders";
import RFQ from "./pages/Admin/RFQ";
import Technicians from "./pages/Admin/Technicians";
import Cutomer from "./pages/Admin/Cutomer";

function SlugRouteHandler() {
  const { slug } = useParams();

  if (slug?.startsWith("appliance-repair-service-in-")) {
    return <AreaPage />;
  }

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <>
      {!isAdminPage && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Service />} />
        <Route path="/about" element={<About />} />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/track-repair" element={<TrackRepair />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route
          path="/lg-appliance-service-bangalore"
          element={<LGMain />}
        />
        <Route
          path="/lg-washing-machine-service-bangalore"
          element={<LGWashingMachineService />}
        />
        <Route
          path="/lg-washing-machine-repair-bangalore"
          element={<LGWashingMachineRepair />}
        />
        <Route
          path="/lg-washing-machine-not-spinning"
          element={<LGWashingMachineNotSpinning />}
        />
        <Route
          path="/lg-washing-machine-not-working-repair"
          element={<LGWashingMachineNotWorking />}
        />
        <Route
          path="/lg-washing-machine-water-leak-repair"
          element={<LGWashingMachineWaterLeakRepair />}
        />
        <Route
          path="/lg-washing-machine-no-power-issue"
          element={<LGWashingMachineNoPowerIssue />}
        />
        <Route
          path="/lg-washing-machine-noise-problem"
          element={<LGWashingMachineNoiseProblem />}
        />
        <Route
          path="/lg-washing-machine-drum-repair"
          element={<LGWashingMachineDrumRepair />}
        />
        <Route
          path="/lg-front-load-washing-machine-service-bangalore"
          element={<LGFrontLoadService />}
        />
        <Route
          path="/lg-top-load-washing-machine-service-bangalore"
          element={<LGTopLoadService />}
        />
        <Route
          path="/washing-machine-service-bangalore"
          element={<WashingMachineService />}
        />
        <Route
          path="/fridge-service-bangalore"
          element={<FridgeService />}
        />
        <Route
          path="/ac-service-bangalore"
          element={<ACService />}
        />
        <Route
          path="/samsung-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="samsung" />}
        />
        <Route
          path="/ifb-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="ifb" />}
        />
        <Route
          path="/whirlpool-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="whirlpool" />}
        />
        <Route
          path="/bosch-appliance-repair-bangalore"
          element={<BrandServicePage brandKey="bosch" />}
        />

        <Route
          path="/appliance-repair-service-in-:area"
          element={<AreaPage />}
        />
        <Route path="/:slug" element={<SlugRouteHandler />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="services" element={<AdminServices />} />
          <Route path="brands" element={<Brands />} />
          <Route path="orders" element={<Orders />} />
          <Route path="rfq" element={<RFQ />} />
          <Route path="technicians" element={<Technicians />} />
          <Route path="customers" element={<Cutomer />} />
          <Route index element={<Navigate to="dashboard" />} />
        </Route>
      </Routes>

      {!isAdminPage && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}
